import {Component} from '@angular/core';

@Component({
    selector: 'app-platform-root',
    templateUrl: './platform-root.component.html',
    standalone: false
})
export class PlatformRootComponent {

}
